// Fecha de nacimiento y edad del pasajero, con fechas como texto 'yyyy-MM-dd' (sin hora ni zona
// horaria). Misma lógica que server/src/utils/edad.ts, que es el que manda: esto es para mostrarle
// al usuario la edad calculada y avisarle antes de enviar.

const FECHA = /^(\d{4})-(\d{2})-(\d{2})$/

function partes(fecha: string) {
    const m = FECHA.exec(fecha)
    if (!m) return null
    const [anio, mes, dia] = [Number(m[1]), Number(m[2]), Number(m[3])]
    const d = new Date(Date.UTC(anio, mes - 1, dia))
    if (d.getUTCFullYear() !== anio || d.getUTCMonth() !== mes - 1 || d.getUTCDate() !== dia) return null
    return { anio, mes, dia }
}

export function hoyTexto(hoy: Date = new Date()) {
    return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`
}

export function edadEn(nacimiento: string, fecha: string = hoyTexto()): number | null {
    const n = partes(nacimiento)
    const f = partes(fecha)
    if (!n || !f) return null
    let edad = f.anio - n.anio
    if (f.mes < n.mes || (f.mes === n.mes && f.dia < n.dia)) edad -= 1
    return edad
}

export const EDAD_MAXIMA = 110

export function errorFechaNacimiento(nacimiento: string, hoy: string = hoyTexto()): string | null {
    if (!partes(nacimiento)) return 'La fecha no es válida'
    const edad = edadEn(nacimiento, hoy)
    if (edad === null || nacimiento > hoy) return 'La fecha no puede ser futura'
    if (edad > EDAD_MAXIMA) return `Da más de ${EDAD_MAXIMA} años: revisa el año`
    return null
}
